import { useEffect, useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Select from "react-select";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { fetchVendor, fetchVendors } from "services/vendor";
import { fetchPurchaseOrders } from "services/purchaseOrder";
import { fetchProducts } from "services/product";

const ProductDrop = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  required,
  setVendorDetails
}) => {
  const login = useSelector((state) => state.jwtAuthreducer);
  const selectedVendorId = watch("product_id");

  const { data: products, isLoading, isError, refetch } = useQuery(
    ["fetch-products"],
    fetchProducts,
    { staleTime: DROPDOWN_STALE_TIME }
  );

  const { data: vendor } = useQuery(
    ["fetch-vendor-by-id", selectedVendorId],
    () => (selectedVendorId ? fetchVendor(selectedVendorId) : null),
    { staleTime: DROPDOWN_STALE_TIME, enabled: !!selectedVendorId }
  );

  if (setVendorDetails) {
    setVendorDetails(vendor?.data);
  }

  useEffect(() => {
    refetch();
  }, [login]);

  const options = useMemo(() => {
    return (
      products?.data?.data?.map((product) => ({
        value: product?.id,
        label: product?.product_name,
      })) || []
    );
  }, [products]);

  useEffect(() => {
    if (rowData && options.length) {
      const selectedOption = options.find(
        (option) => option.value === rowData?.product_id
      );
      setValue("product_id", selectedOption?.value);
    }
  }, [rowData, options, setValue]);

  const selectedOption = options.find(
    (option) => option.value === selectedVendorId
  );

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error loading vendors</div>;

  return (
    <Controller
      name="product_id"
      control={control}
      rules={{
        required: required ? "Purchase Order is required" : false,
        validate: (value) => (required && !value ? "Purchase Order is required" : true),
      }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          placeholder="Select Product"
          value={selectedOption || null}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            control: (base) => ({
              ...base,
              height: "42px",
            }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("product_id", value);

            if (value) {
              fetchVendor(value);
            }
          }}
          className={`react-select-container ${errors.product_id ? "is-invalid" : ""}`}
        />
      )}
    />
  );
};

export default ProductDrop;
